import React from "react";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { Theme } from "@material-ui/core";
import { Classes } from "jss";
import DetailCard, { DetailCardProps } from "./DetailCard";
import { SearchField } from "../inputs/SearchField";

type Props = {
  classes: Classes;
  className?: string;
  details: DetailCardProps[];
  onSubmitSearch: (searchTerm: string) => void;
  btnDisabled?: boolean;
};

type State = {
  search: string;
};

const styles = (theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      flexFlow: "row wrap"
    },
    searchWrapper: {
      display: "flex",
      justifyContent: "flex-end"
    }
  });

class DetailGrid extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      search: ""
    };
    this.onSearchUpdate = this.onSearchUpdate.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onReset = this.onReset.bind(this);
  }

  onSearchUpdate(e: any) {
    e.persist();
    this.setState({
      search: e.target.value
    });
  }

  onSubmit() {
    const search = this.state.search;
    this.props.onSubmitSearch(search);
  }

  onReset() {
    const search = "";
    this.setState({
      search: search
    });
    this.props.onSubmitSearch(search);
  }

  render() {
    const { classes, details, btnDisabled } = this.props;
    const search = this.state.search;
    return (
      <div>
        <div className={classes.searchWrapper}>
          <SearchField
            onUpdate={this.onSearchUpdate}
            value={search}
            onSubmit={this.onSubmit}
            onReset={this.onReset}
          />
        </div>
        <div className={classes.container}>
          {details.map(details => (
            <DetailCard key={details.id} {...details} btnDisabled={btnDisabled} />
          ))}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(DetailGrid);
